import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }

import { onBeforeUnmount, ref } from "vue";
import { useGlobalStore } from "@/stores/GlobalStore";
import TabsWrapper from "@/components/tabs/TabsWrapper.vue";
import TabItem from "@/components/tabs/TabItem.vue";
import ActivityTab from "@/components/tabs/activitySets/ActivityTab.vue";
import ActivitySetTab from "@/components/tabs/activitySets/ActivitySetTab.vue";
import {Store} from "@bryntum/grid";



export default /*@__PURE__*/_defineComponent({
  __name: 'Activities',
  setup(__props) {

const activeTab = ref(0);
const globalStore = useGlobalStore();

onBeforeUnmount(()=>{
	globalStore.setGridStore(new Store());
	globalStore.setGridColumnStore(null);

	globalStore.currentItems = 0;
	globalStore.allItems = 0;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t("activitySet.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(TabsWrapper, { activeTab: activeTab.value }, {
        default: _withCtx(() => [
          _createVNode(TabItem, {
            title: _ctx.$t('activitySet.tabs.groups')
          }, {
            default: _withCtx(() => [
              _createVNode(ActivitySetTab)
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(TabItem, {
            title: _ctx.$t('activitySet.tabs.manageActivities')
          }, {
            default: _withCtx(() => [
              _createVNode(ActivityTab)
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }, 8, ["activeTab"])
    ])
  ], 64))
}
}

})